/**
 * This is used for the introduction wizard
 */

export class Choice {
   enable: Boolean;
   title: string;
   description: string;
   image: string;
   name: string;
   //options: string[]; //the list of dropdown options
   choosen: Boolean;
   
   constructor(enable: boolean, title: string, name: string, description:string, image: string) {
    this.enable = enable;
    this.title = title;
    this.name = name;
    //this.options = options;
    this.image = image;
    this.description = description;
    this.choosen = false; //Set choose to be false by default.
   }

   choose() {
      this.choosen = true;
   }

   deselect() {
      this.choosen = false;
   }
}